import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserIcon, useSetUserIcon } from '../state';
import { FaUserCircle } from 'react-icons/fa';
import { getUserData, logout } from '../services';

const ProfileIcon = () => {
  const userIcon = useUserIcon();
  const setUserIcon = useSetUserIcon();
  const [isOpen, setIsOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Fetch user data to get the icon
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const data = await getUserData(['email', 'icon', 'displayName']);
        console.log('user data retrieved in profile icon component: ', data);
        setUserData(data);
        
        // Update the AppContext with the user's icon
        if (data.icon) {
          setUserIcon(data.icon);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Get initials from user's first and last name
  const getInitials = () => {
    if (userData && userData.displayName) {
      return userData.displayName
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase()
        .substring(0, 2);
    }
    
    return '';
  };

  // Handle navigation to settings
  const handleSettings = () => {
    navigate('/settings');
    setIsOpen(false);
  };

  // Handle logout
  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-center w-10 h-10 rounded-full bg-white overflow-hidden focus:outline-none focus:ring-2 focus:ring-teal-300"
      >
        {userIcon ? (
          <img 
            src={userIcon} 
            alt="Profile" 
            className="w-full h-full object-cover"
          />
        ) : userData && getInitials().trim() ? (
          <div className="w-full h-full flex items-center justify-center bg-[#68C7CC] text-white font-semibold">
            {getInitials()}
          </div>
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-[#68C7CC] text-white">
            <FaUserCircle size={24} />
          </div>
        )}
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20">
          <button
            onClick={handleSettings}
            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
          >
            Settings
          </button>
          <button
            onClick={handleLogout}
            className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100"
          >
            Log out
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileIcon;
